// keys.ts — RQ cache keys for the geo suite. Private.
//
// The key is the content ref, so every map block inside one record shares a
// single cache entry: a deliverable with four map fences issues ONE request, not
// four. That matters more here than elsewhere — geocoding runs against a
// deployment-wide 1-request-per-second budget.

import type { GeoContentRef } from '@cabal/shared/domain/geo/types.js';

const GEO_QUERY_KEY = {
  Root: 'geo',
  Resolve: 'resolve',
} as const;

export const geoKeys = {
  all: [GEO_QUERY_KEY.Root] as const,
  resolve: (ref: GeoContentRef | null) =>
    [
      ...geoKeys.all,
      GEO_QUERY_KEY.Resolve,
      ref?.kind ?? null,
      ref?.sessionId ?? null,
      ref?.recordId ?? null,
    ] as const,
};
